<div class="content-block">
  <article class="article " style="margin-top:1rem">
    <h2>Administrator Home</h2>
    <hr />
    <p>Welcome to the LGS administrator home page.</p>
    <p>
      You are able to administer the sites listed in the drop-down box below. Please select one of the
      customer sites from the list:
    </p>

    <div style="width: 100%;position:relative">
      <app-company-picker [triggerRefetch]="refetchCompanies" [accountId]="filter.companyId" [disable]="disableCompany"
        [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
    </div>
    <div
      style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start; width: 100%;margin-top: 0.5rem;">

      <div style="flex: 8; width: 100%;">
        <div >
          <div class="display-tile-container">
            <div class="card custom-card display-tile title-border shadow" style=" margin-left: 0%;" (click)="createCompany()">
              <p>Create a new customer site</p>
            </div>

            <div class="card custom-card display-tile title-border shadow" *ngIf="user.userProfileId != 4"
              (click)="navigteToEngineerManagement()">
              <p> Add or Amend Inspectors</p>

            </div>


            <div class="card custom-card display-tile title-border shadow" style="margin-right: 0%"
              (click)="navigteToUserManagement()">
              <p> Add or Amend Web Portal Users</p>
            </div>

            <div class="card custom-card display-tile title-border shadow" style="margin-right: 0%"
              (click)="navigteToInspectionImport()">
              <p> Import Inspections</p>
            </div>


          </div>
        </div>
      </div>

    </div>

  </article>
</div>


<popup-modal id="popup-company-add">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Add new Company</h2>
      </div>

      <div class="popup-content">
        <app-company-mange [user]="user" [saveTrigger]="companySaveTrigger"
          (added)="companySave($event)"></app-company-mange>
      </div>

      <div class="popup-footer">
        <div class="btn-container">
          <button class="btn btn-primary" (click)="closeCompanyModal('popup-company-add')">Close</button>
          <button class="btn btn-primary" (click)="triggerCompanySave()">Save</button>

        </div>
      </div>
    </div>
  </article>

</popup-modal>